@if ($model() != null) {
    <form class="px-1" (ngSubmit)="onSubmit()" #flowObjectGatewayRules="ngForm">
        <div class="scroll-wrapper styled-scrollbar px-2">
            <!-- Tipo de regra -->
            <div class="form-group rule-type-container ml-0 mb-2"
                 featureHint="flowObjectDetailsMidwayOutboundApi|HttpSuccessRule" featureHintHAlign="right" featureHintVAlign="top"
            >
                <span>Selecione o tipo de regra que será avaliada pela Tarefa:</span>

                <mat-radio-group class="mb-2" id="httpSuccessRule" name="httpSuccessRule" color="primary"
                                 [ngModel]="$httpSuccessRule()"
                                 (ngModelChange)="httpSuccessRuleChange($event)"
                >
                    <mat-radio-button [value]="true">Código HTTP da classe 2XX</mat-radio-button>
                    <mat-radio-button class="mt-3" [value]="false">Propriedade da API</mat-radio-button>
                </mat-radio-group>
            </div>

            <!-- Configuração da comparação: comportamento -->
            @if ($httpSuccessRule() == false) {
                <div featureHint="flowObjectDetailsMidwayOutboundApi|ShouldIgnoreNoValueError" featureHintHAlign="right" featureHintVAlign="middle">
                    <mat-checkbox id="shouldIgnoreNoValueError" name="shouldIgnoreNoValueError" color="primary"
                                  [ngModel]="$shouldIgnoreNoValueError()"
                                  (change)="$shouldIgnoreNoValueError.set($event.checked)"
                    >
                        Ignorar erros quando o objeto retornado pela API de destino não contiver o campo indicado em "Propriedade"
                        na regra mais abaixo
                    </mat-checkbox>
                </div>

                <div featureHint="flowObjectDetailsMidwayOutboundApi|ShouldIgnoreNonNumberError" featureHintHAlign="right" featureHintVAlign="middle">
                    <mat-checkbox class="mt-2" id="shouldIgnoreNonNumberError" name="shouldIgnoreNonNumberError" color="primary"
                                  [ngModel]="$shouldIgnoreNonNumberError()"
                                  (change)="$shouldIgnoreNonNumberError.set($event.checked)"
                    >
                        Ignorar erros de tipo de valores numéricos para o campo indicado em "Propriedade" na regra mais abaixo
                    </mat-checkbox>
                </div>
            }

            <!-- Configuração da comparação: regra -->
            @if ($showProperties()) {
                <div class="form-group rule-container mt-3 mb-0">
                    <div class="row">
                        <!-- Propriedade -->
                        <div class="form-group col" featureHint="flowObjectDetailsMidwayOutboundApi|PropertyKey" featureHintVAlign="bottom">
                            <label for="propertyKey">Propriedade</label>

                            <input type="text" class="form-control" id="propertyKey" name="propertyKey" placeholder="e.g. &quot;userId&quot;"
                                   [ngModel]="$propertyKey()"
                                   (change)="$propertyKey.set($event.target.value)"
                            >
                        </div>

                        <!-- Operador -->
                        <div class="form-group col" featureHint="flowObjectDetailsMidwayOutboundApi|RuleOperator" featureHintVAlign="bottom">
                            <label for="ruleOperator">Operador</label>

                            <select class="form-control" id="ruleOperator" name="ruleOperator"
                                    [ngModel]="$ruleOperator()"
                                    (change)="ruleOperatorChange($event.target.value)"
                            >
                                @for (option of gatewayRuleOperatorOptions; track option) {
                                    <option [value]="option.value">{{option.description}}</option>
                                }
                            </select>
                        </div>

                        <!-- Valor -->
                        <div class="form-group col" featureHint="flowObjectDetailsMidwayOutboundApi|PropertyValue" featureHintVAlign="bottom">
                            @let placeholder = $ruleOperator() <= GatewayRuleOperator.LessThan
                                ? 'e.g. "10"'
                                : $ruleOperator() == GatewayRuleOperator.IsTrue
                                    ? 'e.g. "true"'
                                    : $ruleOperator() == GatewayRuleOperator.IsFalse
                                        ? 'e.g. "false"'
                                        : $ruleOperator() == GatewayRuleOperator.IsNull
                                            ? 'e.g. "null"'
                                            : $ruleOperator() == GatewayRuleOperator.IsNotNull
                                                ? 'e.g. "Inscrição confirmada. Número: 1234."'
                                                : $ruleOperator() == GatewayRuleOperator.IsEmpty
                                                    ? 'e.g. ""'
                                                    : $ruleOperator() == GatewayRuleOperator.IsNotEmpty
                                                        ? 'e.g. "Registro efetuado."'
                                                        : 'e.g. "termo a ser pesquisado"';
                            <label for="value">Valor</label>
                            <input type="text" class="form-control" id="propertyValue" name="propertyValue"
                                   [ngModel]="$propertyValue()"
                                   [placeholder]="placeholder"
                                   [disabled]="$valueDisabled()"
                                   (change)="$propertyValue.set($event.target.value)"
                            >
                        </div>
                    </div>
                </div>
            }

            <!-- Mensagem -->
            <div class="form-group ml-0" featureHint="flowObjectDetailsMidwayOutboundApi|Message" featureHintHAlign="right" featureHintVAlign="middle">
                <label for="message">Mensagem</label>

                <textarea type="text" class="form-control" id="message" name="message" rows="2"
                            placeholder="e.g. &quot;Entre em contato com (...)&quot;"
                            [ngModel]="$message()"
                            (change)="$message.set($event.target.value)"
                ></textarea>
            </div>
        </div>

        <!-- Botões -->
        <div class="form-footer text-right mb-1">
            <hr class="mt-0" />

            <!-- ConfigSchema -->
            <div class="button-wrapper float-left ml-1" featureHint="flowObjectDetails|ConfigSchemaButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-secondary" (click)="showConfigSchema()">Editar código-fonte</button>
            </div>

            <!-- Cancelar -->
            <div class="button-wrapper mr-2" featureHint="flowObjectDetails|CancelButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-danger" (click)="closeForm()">Cancelar</button>
            </div>

            <!-- Salvar -->
            <div class="button-wrapper" featureHint="flowObjectDetails|SaveButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="submit" class="btn btn-outline-primary"
                        [disabled]="!flowObjectGatewayRules.form.valid || $isReadOnlyMode()"
                >Salvar Rascunho</button>
            </div>
        </div>
    </form>

    <!-- Modal do ConfigSchema -->
    <ng-template #configSchemaRef>
        <i class="button fas fa-times close" matTooltip="Fechar" (click)="configSchemaDialog.close()"></i>

        <button type="button" class="button btn btn-primary" (click)="Utils.copyToClipboard(configSchemaEditorRef, copyInfoRef);">
            <i class="fas fa-copy mr-2"></i>
            <span>Copiar conteúdo</span>
        </button>

        <button type="button" class="button btn btn-outline-info info" #copyInfoRef><span>Conteúdo copiado!</span></button>
        <button type="button" class="button btn btn-outline-info info" #pasteInfoRef><span>Conteúdo colado!</span></button>

        <button type="button" class="button btn btn-success right" (click)="Utils.pasteFromClipboard(configSchemaEditorRef, pasteInfoRef)">
            <i class="fas fa-paste mr-2"></i>
            <span>Colar conteúdo</span>
        </button>

        <textarea class="schema-editor form-control styled-scrollbar" [ngModel]="$configSchemaFlat()" #configSchemaEditorRef></textarea>
    </ng-template>
}
